import { Injectable } from '@angular/core';
import { LabelPrintingType } from './label-printing.component';

@Injectable()
export class LabelPrintingContext {
    studyId: number;
    studyName: string;
    datasetId: number;
    selectedGIDs: number[];
    isBrowseAllGermplasmResults: boolean;
    selectedLotUUIDs: string[];
    printingLabelType: LabelPrintingType;
    searchRequestId: number;
    listId: number;
    sampleListId: number;
    selectedColumns: string[];
    // FIXME: Once the old study manager is removed. This is no longer necessary
    openedDirectlyFromNewStudyEditor: boolean;
}
